<template>
    <section class="contact"   >

      <div class="contact-box item-cont" :class="{'vis' :  offSet.last >= 0}" >
        <div class="contact-box-black">

          <div class="contact-box-headline">
             <h1 class="aux" v-html="headline[lang]"></h1>
            <div class="aux2">&nbsp; <br>&nbsp;</div>
          </div>

          <div class="contact-box-headline-text" >
              <span v-html="text[lang]"></span><br>
            <a class="" href="mailto:newbusiness@nossa.pt" target="_blank">newbusiness@nossa.pt</a>

          </div>




          <div class="contact-box-address">
            <strong>Algés, Oeiras</strong><br>
            Rua Mestre de Aviz 29<br>
            <a href="tel:+35121400680" target="_blank"> + 351 214 000 680</a>
            <div  v-if="lang == 0" style="font-size: 0.7em; line-height: 1em;">(chamada para rede nacional)</div>
            <div  v-if="lang == 1" style="font-size: 0.7em; line-height: 1em;">(call to the landline network)</div>
          </div>
        </div>
        <div class="contact-box-map">
          <GoogleMap></GoogleMap>
        </div>
      </div>




      <div class="work-us item-cont" :class="{'vis' :  offSet.last >= 1}">

        <div class="work-us-box">
          <div class="work-us-headline" v-html="headline2[lang]"></div>
          <div class="work-us-text" v-html="text2[lang]"></div>
        </div>
        <div class=" "></div>






      </div>


      <div class="work-us-opportunitys"  :class="{'vis' :  offSet.last >= 2}">
        <div v-for="(item, index) in jobData"  class="work-us-opportunitys-item">
          <h2>{{item.title[lang].name}}</h2>
          <p v-html="item.text[lang].name"></p>
          <a :href="item.link" target="_blank">{{item.cta[lang].name}}</a>

        </div>
      </div>




      <div class="project-footer">
        <footer-nossa :lang="lang" :isMobile="isMobile"></footer-nossa>
      </div>


    </section>
</template>

<script>




    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../main';
    import MediaType from "./Modules/MediaType";


    import FooterNossa from "./FooterNossa";
    import Icons from "./Modules/Icons";
    import GoogleMap from "./Modules/GoogleMap";
    import {NavEvents} from "../dataModules/NavEvents";


   // import Masonry from "masonry-layout/masonry";






    export default {


        name: 'contact',
      components: {GoogleMap, Map, Icons, FooterNossa, MediaType},
      props: ['actRoute', 'isMobile', 'lang'],
        data() {
            return {
                actScreen: 0,
              headline: ['A coisa mais interessante <br>que aconteceu a Algés', 'The most interesting thing <br class="d©">that happened to Algés'],
              text: ['Sim, também gostava que <br>a minha marca fosse <strong style="font-weight: 600!important;">NOSSA</strong>', 'Yes, I would also like <br>my brand to be <strong style="font-weight: 600!important;">NOSSA</strong>'],
              headline2: [' Queres vir trabalhar<br>  para a NOSSA?', ' Do you want <br>to work at NOSSA'],
              text2: ['Que distúrbio tens para desejares uma coisa dessas?<br> Envia-nos a tua interessante história para <a href="mailto:queroser@NOSSA.pt" target="_blank">queroser@NOSSA.pt</a> ',
              'What disorder do you have to want such a thing?<br>Send us your interesting story to <a href="mailto:queroser@NOSSA.pt" target="_blank">queroser@NOSSA.pt</a> '],
              jobData: [],
              offSet: {
                vis: [],
                tops: [],
                last: -1
              },
              loaded: false,
              ready: false,


              vFoot:false,

            }
        },
      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: '|',   complement: 'Contactos'
          }
        },


      },
      created() {
          const _this = this;


        WP('job', function (response){
          console.log(response)

          _this.jobData = response;
          _this.loaded = true;

          /*
                      if(_this.homeData.html) {
                        _this.totalScreens ++;
                      }

                      if(_this.homeData.blog) {
                        _this.totalScreens ++;
                      }

          */

          _this.init();


        });


      },
      mounted() {

        $(window).scrollTop(0);
        $('body, html').scrollTop(0);

        this.ready = true;
        this.init();








      },

      destroyed() {
        $(window).off();
      },

      methods: {

        init() {

          const _this = this;

          if(this.loaded && this.ready){


            this.initScroll();


          }



        },

        initScroll(){
          const _this = this;


          setTimeout(() =>{

            $('.item-cont').each(function(i){

              _this.offSet.tops.push($(this).offset().top);
             // _this.offSet.tops.push($('.work-us').offset().top);

            });

            $( window ).scroll(function(e) {

              _this.scrollEvt()
            });

            $( window ).resize(function() {
              _this.reseizeMe();
            });

            _this.reseizeMe();
            _this.scrollEvt();
            this.offSet.last = 0;
          }, 100)




        },

        reseizeMe() {

          this.scrollEvt()
        },

        scrollEvt() {

          const _this = this;

          _this.offSet.act =  $( window ).scrollTop() +  $( window ).height();




          if(_this.offSet.act > ($('.work-us').offset().top  + 200 ) ) {
            _this.offSet.last = 1;
          }
          if(_this.offSet.act > ($('.work-us-opportunitys').offset().top  + 200 ) ) {
            _this.offSet.last = 2;
          }
         // console.log(_this.offSet.act, ($('.project-footer').offset().top  + 200 ), _this.vFoot)

          if(_this.offSet.act > ($('.project-footer').offset().top  + 200 )  && !_this.vFoot) {
            _this.offSet.last = 2;
            _this.vFoot = true;

            EVENTBUS.$emit('showFooter');
          }













          /*



          if(this.offSet.act > this.offSet.off2.top &&  !this.offSet.vis2) {
            this.offSet.vis2 = true;

          }
*/



          // $( window ).scrollTop()
          // console.log(this.offSet );
        },


        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Contact.vue